import './styles.scss'
import { Link } from 'react-router-dom'
import downArrow from '../../images/downArrow.svg'
import classNames from 'classnames'
export default function CMSTable(props) {
  const { columns, data, showEditControls, deleteRow, sortColumn, sortDirection, sortable, sort, rowToDelete } = props
  return (
    <div className='CMSTable'>
      <table>
        <thead>
          <tr>
            {columns.map(column => {
              const isSortColumn = sortColumn === column.key
              const sortTransform = sortDirection === 'asc' ? 'translate(0, -0.2em)' : 'rotate(180deg) translate(0, 0.2em)'
              const sortIcon = isSortColumn ?  <img src={downArrow} alt='sort' style={{ position: 'absolute', transform: sortTransform }}/> : null
              const columnSortable = sortable && !column.notSortable
              return (
                <th
                  onClick={columnSortable ? () => sort(column.key) : null}
                  className={classNames('bold', {sortable: columnSortable})}
                  key={column.name}
                  style={{ width: column.width }}
                  >
                    {column.name}{sortIcon}
                </th>
              )
            })}
            {showEditControls ? <th className='bold'>Edit</th> : false}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => {
            const deleting = rowToDelete === row
            return (
              <tr key={i} className={classNames({deleting})}>
                {columns.map((column, columnIndex) => {
                  const value = column.accessor(row)
                  let cell = value
                  if (showEditControls && columnIndex === 0) {
                    cell = (
                      <Link to={`edit/${row['NO_ID_FIELD']}`}>{value}</Link>
                    )
                  }
                  return (
                    <td key={column.name}>{cell}</td>
                  )
                })}
                {showEditControls ? (
                  <td style={{ whiteSpace: 'nowrap'}}>

                    <Link className='icon editIcon' to={`edit/${row['NO_ID_FIELD']}`}>Edit</Link>
                    <button className='deleteIcon' onClick={deleteRow(row)}>Delete</button>

                  </td>
                ) : null }


              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
